import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import {DialogContent , DialogTitle , DialogActions} from "@material-ui/core";
import { ButtonBase } from "@material-ui/core";
import "./styles.scss";
import {WarningOutlined} from "@material-ui/icons";
import Button from "@material-ui/core/Button";

function SetMode({ SubmitData, modeSet }) {
  const [state, setState] = useState({
    Modes: [1 , 2 , 3 , 4 , 5 , 6],
    ModeInfo: [
      {
        name: "مشاوره",
        price: 173000,
        disabled: false
      },
      {
        name: "مامز کلاب",
        price: 600000,
        disabled: false
      },
      {
        name: "کلاب خصوصی کودک",
        price: 720000,
        disabled: false
      },
      {
        name: "کارگاه رابطه مادر و کودک",
        price: 400000,
        disabled: false

      },
      {
        name: "کلاب گروهی کودک",
        price: 700000,
        disabled: false
      },
      {
        name: "کارگاه تک جلسه ای",
        price: 45000,
        disabled: false

      }
    ],
    selectedMode: "",
  });

  const [dynamicClassName, setDynamicClassName] = React.useState("");
  const [price, setPrice] = React.useState(0);
  const [dialogState , setDialogState] = React.useState(false);

  const ChangeMode = (value) => {
    setState({
      ...state,
      selectedMode: value,
    });
    modeSet(value - 1);
    SubmitData(state.ModeInfo[value - 1], "step1");
  };

  const countToEnd = (end) => {
    setPrice(0);
    let pr = 0;
    let val = end / 200;
    const inter = setInterval(() => {
      if (pr < end) {
        pr += val;
        setPrice(pr);
      } else {
        clearInterval(inter);
      }
    }, 1);
  };

  return (
    <div>
      <div className="w-100">
        <div className={"p-2"}>انتخاب دوره</div>

        <div
          className={`w-100 text-center p-3 ${
            state.selectedMode === null || state.selectedMode === ""
              ? ""
              : price === state.ModeInfo[state.selectedMode - 1].price
              ? "done-calc"
              : ""
          }`}
        >
          {state.selectedMode !== "" ? (
            <span
              className={`font-weight-bold text ${
                price === state.ModeInfo[state.selectedMode - 1].price
                  ? "text-success"
                  : "text-primary"
              }`}
            >
              {price + "T"}
            </span>
          ) : (
            ""
          )}
        </div>
        <div className="button-container">
          {state.ModeInfo.map((item, index) => (
            <ButtonBase
              onClick={() => {
                ChangeMode(index + 1);
                countToEnd(item.price);
                setDynamicClassName(index.toString());
                if(index === state.ModeInfo.length - 1) {
                  setDialogState(true);
                }
              }}
              disabled={item.disabled}
              key={`MI-${index}`}
              className={`circular-button ${
                item.disabled 
                  ? "btn-disabled"
                  : dynamicClassName === ""
                  ? ""
                  : dynamicClassName === index.toString()
                  ? "btn-selected"
                  : ""
              } btn-${!item.disabled ?  index + 1 : 'disabled'}`}
            >
              {item.name}
            </ButtonBase>
          ))}
        </div>
      </div>
      <Dialog
        open={dialogState}
        onClose={() => setDialogState(false)}
        fullWidth
      >

        <DialogTitle className={'text-warning'}>
          <WarningOutlined />
           توجه !
          <hr/>
        </DialogTitle>
        <DialogContent>
          مبلغ ذکر شده برای کارگاه تک جلسه به ازای هر کارگاه محاسبه میشود. هر کارگاه 45000 تومان میباشد
        </DialogContent>
        <DialogActions>
          <Button
            variant={"contained"}
            color={"primary"}
            onClick={() => setDialogState(false)}
          >
            متوجه شدم
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
export default SetMode;
